import { DateTime } from "luxon";
import { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";

/**
 * True when the dialog's inclusive calendar date range (yyyy-MM-dd in `zone`) lies fully inside
 * the calendar's loaded schedule window (`calendarRange*Iso` from Mobiscroll / parent state).
 */
export function isDialogDateRangeWithinCalendarPrefetchRange(
  dialogFromYmd: string,
  dialogToYmd: string,
  calendarRangeStartIso: string,
  calendarRangeEndIso: string,
  zone: string
): boolean {
  const dStart = DateTime.fromISO(dialogFromYmd, { zone }).startOf("day");
  const dEnd = DateTime.fromISO(dialogToYmd, { zone }).endOf("day");
  if (!dStart.isValid || !dEnd.isValid || dEnd < dStart) {
    return false;
  }

  const pStart = DateTime.fromISO(calendarRangeStartIso).setZone(zone).startOf("day");
  const pEnd = DateTime.fromISO(calendarRangeEndIso).setZone(zone).endOf("day");
  if (!pStart.isValid || !pEnd.isValid) {
    return false;
  }

  return dStart >= pStart && dEnd <= pEnd;
}

/** Schedules whose booking interval overlaps the dialog's inclusive date range in `zone`. */
export function selectSchedulesOverlappingDialogDateRange(
  schedules: readonly BookingScheduleInterface[],
  dialogFromYmd: string,
  dialogToYmd: string,
  zone: string
): BookingScheduleInterface[] {
  const rangeStart = DateTime.fromISO(dialogFromYmd, { zone }).startOf("day");
  const rangeEnd = DateTime.fromISO(dialogToYmd, { zone }).endOf("day");
  if (!rangeStart.isValid || !rangeEnd.isValid) {
    return [];
  }

  return schedules.filter(s => {
    const sStart = DateTime.fromISO(s.startDate).setZone(zone);
    const sEnd = DateTime.fromISO(s.endDate).setZone(zone);
    if (!sStart.isValid || !sEnd.isValid) {
      return false;
    }
    return sStart <= rangeEnd && sEnd >= rangeStart;
  });
}
